<template>
  <div>
    <div style="margin-bottom: 20px;">
      <Button
        :label="t('Adicionar Serviço Adicional')"
        icon="pi pi-plus"
        size="small"
        data-testid="so-additional-services-add-btn"
        @click="handleNew"
      />
    </div>

    <s-o-additional-services-table
      ref="soAdditionalServicesTableRef"
      @edit="handleEdit"
      @delete="handleDelete">
    </s-o-additional-services-table>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import SOAdditionalServicesTable from './SOAdditionalServicesTable.vue';
import { log } from '../../utils/DebugLogger';

type Id = number | string;

interface DataTableInstance {
  loadData: () => void;
}

const { t } = useI18n();

const soAdditionalServicesTableRef = ref<DataTableInstance | null>(null);

const loadData = async (): Promise<void> => {
  log('SOAdditionalServicesPage', 'loadData', 'Reloading data');
  if (soAdditionalServicesTableRef.value) {
    await soAdditionalServicesTableRef.value.loadData();
  }
};

const handleNew = (): void => {
  log('SOAdditionalServicesPage', 'handleNew', 'Opening modal for new additional service');
  eventBus.emit('modal.so-additional-services.open', { action: 'create' });
};

const handleEdit = (id: Id): void => {
  log('SOAdditionalServicesPage', 'handleEdit', 'Editing additional service', id);
  eventBus.emit('modal.so-additional-services.open', { id, action: 'edit' });
};

const handleDelete = (id: Id, data: Record<string, unknown> | null = null): void => {
  log('SOAdditionalServicesPage', 'handleDelete', 'Deleting additional service', id);
  eventBus.emit('modal.so-additional-services.open', { id, data, action: 'delete' });
};

const handleNewEvent = (): void => handleNew();
const handleEditEvent = (id?: Id): void => { if (id !== undefined) handleEdit(id); };
const handleDeleteEvent = (id?: Id): void => { if (id !== undefined) handleDelete(id); };

onMounted(() => {
  log('SOAdditionalServicesPage', 'mounted', 'Component mounted');
  eventBus.on('so-additional-service.new', handleNewEvent);
  eventBus.on('so-additional-service.edit', handleEditEvent);
  eventBus.on('so-additional-service.delete', handleDeleteEvent);
});

onBeforeUnmount(() => {
  eventBus.off('so-additional-service.new', handleNewEvent);
  eventBus.off('so-additional-service.edit', handleEditEvent);
  eventBus.off('so-additional-service.delete', handleDeleteEvent);
});

defineExpose({ loadData, handleNew, handleEdit, handleDelete });
</script>
